module.exports = __webpack_public_path__ + "static/media/move.21f43ff7.png";